import { RadioButtonGroup } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { ViewStore } from '../stores/ViewStore';
import type { WidgetView } from '../types';

type ViewSelectorProps = {
  viewStore: ViewStore;
  disabled?: boolean;
};

export const ViewSelector = observer(function ViewSelector({ viewStore, disabled }: ViewSelectorProps) {
  const { t } = useTranslation();

  const selectorValue: WidgetView =
    viewStore.current.name === 'autoAnomalies' || viewStore.current.name === 'manualAnomalies'
      ? 'autoAnomalies'
      : 'alertRulesTime';

  const items: { label: string; value: WidgetView; disabled?: boolean }[] = [
    {
      label: t('alertsManagerWidget:viewSelector.alertRules'),
      value: 'alertRulesTime',
      disabled,
    },
    {
      label: t('alertsManagerWidget:viewSelector.events'),
      value: 'autoAnomalies',
      disabled,
    },
  ];

  return (
    <RadioButtonGroup
      items={items}
      value={selectorValue}
      onChange={(value) => {
        if (value === 'autoAnomalies') {
          viewStore.select('autoAnomalies');
        } else {
          viewStore.select('alertRulesTime');
        }
      }}
    />
  );
});
